import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "src/store/actions";
import {
  ManualTransferPO,
  fetchProductPricingForPoItem,
  fetchStoreListForMT,
  fetchTransferDetails,
  searchProductsforMT
} from "./ManualTransferAsyncThunks";
import {
  handleAddAttachment,
  handleAdditem,
  handleClearSearchResult,
  handleEditReceivedCases,
  handleEditReceivedEaches,
  handleEnableSort,
  handleFulFillFetchTransferDetails,
  handleFulfillManualTransferTransferPo,
  handleFulfillFetchStoreListForMT,
  handleFulfillSearchProductForMt,
  handlePendingManualTransferTransferPo,
  handlePendingFetchStoreListForMT,
  handlePendingFetchTransferDetails,
  handlePendingSearchProductForMt,
  handleRejectManualTransferTransferPo,
  handleRejectFetchStoreListForMT,
  handleRejectFetchTransferDetails,
  handleRejectSearchProductForMt,
  handleRemoveAttachment,
  handleRemovePoItem,
  handleReset,
  handleSearchPoItem,
  handleUpdateCreatedBy,
  handleUpdateNavigationBlocking,
  handleUpdateNotes,
  handleUpdateReceivingStore,
  initialState,
  handleEditCostAndRetail,
  handleFulfillProductPricing,
  handleRejectProductPricing
} from "./ManualTransferReducers";

const ManualTransferSlice = createSlice({
  name: "manualTransfer",
  initialState,
  reducers: {
    handleAdditem,
    handleRemovePoItem,
    handleSearchPoItem,
    handleClearSearchResult,
    handleEditReceivedEaches,
    handleEditReceivedCases,
    handleReset,
    handleUpdateNavigationBlocking,
    handleUpdateReceivingStore,
    handleUpdateCreatedBy,
    handleUpdateNotes,
    handleAddAttachment,
    handleEnableSort,
    handleRemoveAttachment,
    handleEditCostAndRetail
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, handleReset)
      .addCase(ManualTransferPO.pending, handlePendingManualTransferTransferPo)
      .addCase(
        ManualTransferPO.fulfilled,
        handleFulfillManualTransferTransferPo
      )
      .addCase(ManualTransferPO.rejected, handleRejectManualTransferTransferPo)
      .addCase(searchProductsforMT.pending, handlePendingSearchProductForMt)
      .addCase(searchProductsforMT.fulfilled, handleFulfillSearchProductForMt)
      .addCase(searchProductsforMT.rejected, handleRejectSearchProductForMt)
      .addCase(fetchStoreListForMT.pending, handlePendingFetchStoreListForMT)
      .addCase(fetchStoreListForMT.fulfilled, handleFulfillFetchStoreListForMT)
      .addCase(fetchStoreListForMT.rejected, handleRejectFetchStoreListForMT)
      .addCase(fetchTransferDetails.pending, handlePendingFetchTransferDetails)
      .addCase(
        fetchTransferDetails.fulfilled,
        handleFulFillFetchTransferDetails
      )
      .addCase(fetchTransferDetails.rejected, handleRejectFetchTransferDetails)
      .addCase(
        fetchProductPricingForPoItem.fulfilled,
        handleFulfillProductPricing
      )
      .addCase(
        fetchProductPricingForPoItem.rejected,
        handleRejectProductPricing
      );
  }
});

export const {
  handleAdditem: addPOItem,
  handleRemovePoItem: removePOItem,
  handleSearchPoItem: searchPOItems,
  handleClearSearchResult: clearSearchResults,
  handleEditReceivedCases: editReceivedCases,
  handleEditReceivedEaches: editReceivedEaches,
  handleReset: reset,
  handleUpdateNavigationBlocking: updateNavigationBlocking,
  handleUpdateReceivingStore: updateReceivingStore,
  handleUpdateNotes: updateNotes,
  handleAddAttachment: addAttachment,
  handleRemoveAttachment: removeAttachment,
  handleUpdateCreatedBy: updateCreatedBy,
  handleEnableSort: enableSort,
  handleEditCostAndRetail: editCostAndRetail
} = ManualTransferSlice.actions;

export default ManualTransferSlice.reducer;
